import { FaSpinner } from 'react-icons/fa'
import useSponsorsActions from '../../hooks/useSponsorsActions'
import { toastError, toastSuccess } from '../../../helper'
import { useNavigate } from 'react-router-dom'
import ImageInput from '../../../core/components/UI/ImageInput'
import { useRef, useState } from 'react'
import RichTextEditor from '../../../core/components/UI/RichTextEditor'
import useCountries from '../../../core/hooks/useCountries'

export default function FormCreateSponsor() {
  const navigate = useNavigate()
  const { countries } = useCountries()

  const { createSponsor, inProgress } = useSponsorsActions()
  const [sponsorLogo, setSponsorLogo] = useState(null)
  const [sponsorBanner, setSponsorBanner] = useState(null)
  const nameArRef = useRef(null)
  const nameEnRef = useRef(null)
  const emailRef = useRef(null)
  const phoneRef = useRef(null)
  const CountryIdRef = useRef(null)
  const youtubeLinkRef = useRef(null)
  const instagramLinkRef = useRef(null)
  const facebookLinkRef = useRef(null)
  const twitterLinkRef = useRef(null)
  const linkedinLinkRef = useRef(null)
  const websiteLinkRef = useRef(null)
  const snapchatLinkRef = useRef(null)
  const sponsorPackageIdRef = useRef(null)
  const isPublishedRef = useRef(null)
  const descriptionBodyArRef = useRef('')
  const descriptionBodyEnRef = useRef('')
  const handleOnSubmitCreateSponsorForm = async (event) => {
    event.preventDefault()
    try {
      const payload = {
        logo: sponsorLogo,
        name_ar: nameArRef.current.value,
        name_en: nameEnRef.current.value,
        email: emailRef.current.value,
        phone: phoneRef.current.value,
        country_id: CountryIdRef.current.value,
        youtube: youtubeLinkRef.current.value,
        instagram: instagramLinkRef.current.value,
        facebook: facebookLinkRef.current.value,
        x: twitterLinkRef.current.value,
        linkedin: linkedinLinkRef.current.value,
        website_url: websiteLinkRef.current.value,
        snapchat: snapchatLinkRef.current.value,
        sponsor_package_id: sponsorPackageIdRef.current.value,
        is_published: isPublishedRef.current.value,
        description_ar: descriptionBodyArRef.current.getContent(),
        description_en: descriptionBodyEnRef.current.getContent(),
        banner: sponsorBanner,
      }
      const message = await createSponsor(payload)
      if (message) {
        toastSuccess(message)
        navigate('/sponsors')
      }
    } catch (error) {
      toastError(error.response.data.error)
    }
  }

  return (
    <form
      onSubmit={handleOnSubmitCreateSponsorForm}
      className="flex flex-col gap-4"
    >
      <div className="flex flex-col gap-4 md:flex-row">
        <div className="flex flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_SPONSOR_LOGO"
          >
            شعار الراعي<span className="text-danger-600">*</span>
          </label>
          <ImageInput
            id="ID_SPONSOR_LOGO"
            onChange={(image) => setSponsorLogo(image)}
          />
        </div>

        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_SPONSOR_BANNER"
          >
            بانر الراعي<span className="text-danger-600">*</span>
          </label>
          <ImageInput
            id="ID_SPONSOR_BANNER"
            className="w-full"
            onChange={(image) => setSponsorBanner(image)}
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 md:flex-row">
        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_SPONSOR_NAME_AR"
          >
            اسم الراعي بالعربية <span className="text-danger-600">*</span>
          </label>
          <input
            id="ID_SPONSOR_NAME_AR"
            ref={nameArRef}
            type="text"
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
          />
        </div>

        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold line-clamp-1"
            htmlFor="ID_SPONSOR_NAME_EN"
          >
            اسم الراعي بالإنجليزية <span className="text-danger-600">*</span>
          </label>
          <input
            id="ID_SPONSOR_NAME_EN"
            ref={nameEnRef}
            type="text"
            className="px-3 py-2 leading-none border-2 outline-none border-muted-500"
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 md:flex-row">
        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_SPONSOR_EMAIL"
          >
            البريد الإلكتروني <span className="text-danger-600">*</span>
          </label>
          <input
            id="ID_SPONSOR_EMAIL"
            ref={emailRef}
            type="email"
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
          />
        </div>

        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_SPONSOR_PHONE"
          >
            رقم الهاتف <span className="text-danger-600">*</span>
          </label>
          <input
            id="ID_SPONSOR_PHONE"
            ref={phoneRef}
            type="tel"
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 md:flex-row">
        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_SPONSOR_COUNTRY"
          >
            الدولة<span className="text-danger-600">*</span>
          </label>
          <select
            ref={CountryIdRef}
            className="px-6 py-2 bg-white border outline-none focus:bg-white"
          >
            <option value="">اختر الدولة</option>
            {countries?.map((country) => (
              <option
                key={country.id}
                value={country.id}
              >
                {country.name_ar}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_YOUTUBE_LINK"
          >
            رابط قناتك على YouTube
          </label>
          <input
            id="ID_YOUTUBE_LINK"
            ref={youtubeLinkRef}
            type="url"
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 md:flex-row">
        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_INSTAGRAM_LINK"
          >
            رابط حسابك على Instagram
          </label>
          <input
            id="ID_INSTAGRAM_LINK"
            ref={instagramLinkRef}
            type="url"
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
          />
        </div>

        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_FACEBOOK_LINK"
          >
            رابط حسابك على Facebook
          </label>
          <input
            id="ID_FACEBOOK_LINK"
            ref={facebookLinkRef}
            type="url"
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
          />
        </div>
      </div>
      <div className="flex flex-col gap-4 md:flex-row">
        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_TWITTER_LINK"
          >
            رابط حسابك على Twitter
          </label>
          <input
            id="ID_TWITTER_LINK"
            ref={twitterLinkRef}
            type="url"
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
          />
        </div>

        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_LINKEDIN_LINK"
          >
            رابط حسابك على LinkedIn
          </label>
          <input
            id="ID_LINKEDIN_LINK"
            ref={linkedinLinkRef}
            type="url"
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
          />
        </div>
      </div>
      <div className="flex flex-col gap-4 md:flex-row">
        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_WEBSITE_LINK"
          >
            رابط الموقع الإلكتروني
          </label>
          <input
            id="ID_WEBSITE_LINK"
            ref={websiteLinkRef}
            type="url"
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
          />
        </div>

        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_SNAPCHAT_LINK"
          >
            رابط حسابك على Snapchat
          </label>
          <input
            id="ID_SNAPCHAT_LINK"
            ref={snapchatLinkRef}
            type="url"
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 md:flex-row">
        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="CATEGORY_ID"
          >
            باقة الرعاية
          </label>
          <select
            ref={sponsorPackageIdRef}
            className="px-6 py-2 bg-white border outline-none focus:bg-white"
          >
            <option value="1">الراعي الماسـي</option>
            <option value="2">الراعي الذهبي</option>
          </select>
        </div>

        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_SNAPCHAT_LINK"
          >
            النشر
          </label>
          <select
            className="px-6 py-2 bg-white border outline-none focus:bg-white"
            ref={isPublishedRef}
          >
            <option value={1}>تم النشر</option>
            <option value={0}>لم يتم النشر</option>
          </select>
        </div>
      </div>
      <div className="flex flex-col w-full gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_HISTORY_EN"
        >
          الوصف بالعربية
        </label>
        <RichTextEditor
          onInit={(event, editor) => (descriptionBodyArRef.current = editor)}
        />
      </div>
      <div className="flex flex-col w-full gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_HISTORY_EN"
        >
          الوصف بالإنجليزية
        </label>
        <RichTextEditor
          dir="ltr"
          onInit={(event, editor) => (descriptionBodyEnRef.current = editor)}
        />
      </div>
      <button
        type="submit"
        disabled={inProgress}
        className="flex items-center justify-center w-full gap-2 px-6 py-3 font-bold text-white border-2 outline-none border-primary-600 bg-primary-600 hover:border-accent-600 hover:bg-accent-600 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
      >
        {inProgress ? (
          <>
            <FaSpinner
              size={16}
              className="animate-spin"
            />
            <span>جاري إنشاء الراعي...</span>
          </>
        ) : (
          <span>إنشاء الراعي</span>
        )}
      </button>
    </form>
  )
}
